import axios from 'axios';

export const adsAxios = axios.create({
  baseURL: `${process.env.REACT_APP_SERVER_URI}/ads`,
});